export default "__VITE_ASSET__CeLACQfw__"